module.exports = __webpack_public_path__ + "static/media/thomas-tucker-au3CYbd7vCU-unsplash.323de194.jpg";